import { useEffect, useState } from 'react';

import { isValidCity } from 'qualification/schema/questions/cityQuestion';
import { CityValue } from 'qualification/schema/questions/cityQuestion';
import { getCityInLocalStorage } from 'shared/helpers/cities';

interface UseCityProps {
  cityFromPath?: string;
}

const useCity = ({ cityFromPath }: UseCityProps = {}):
  | CityValue
  | undefined => {
  const [city, setCity] = useState<CityValue | undefined>(undefined);

  useEffect(() => {
    let fetchedCity = cityFromPath || getCityInLocalStorage() || undefined;

    if (fetchedCity) {
      fetchedCity = isValidCity(fetchedCity) ? fetchedCity : 'other';
    }

    setCity(fetchedCity as CityValue);
  }, [cityFromPath]);

  return city;
};

export default useCity;
